/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, exercises: NonNullable<unknown>, volume: NonNullable<unknown> }} Coaching_Workout_LineInputs */

const en_us2_coaching_workout_line = /** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sets: ${i?.sets} · exercises: ${i?.exercises} · volume: ${i?.volume}`)
};

const pt_br2_coaching_workout_line = /** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries: ${i?.sets} · exercícios: ${i?.exercises} · volume: ${i?.volume}`)
};

const pt_pt2_coaching_workout_line = /** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries: ${i?.sets} · exercícios: ${i?.exercises} · volume: ${i?.volume}`)
};

/** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */
const es_419_coaching_workout_line = en_us2_coaching_workout_line;

/** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */
const fr_fr2_coaching_workout_line = en_us2_coaching_workout_line;

/** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */
const de_de2_coaching_workout_line = en_us2_coaching_workout_line;

/** @type {(inputs: Coaching_Workout_LineInputs) => LocalizedString} */
const it_it2_coaching_workout_line = en_us2_coaching_workout_line;

/**
* | output |
* | --- |
* | "Sets: {sets} · exercises: {exercises} · volume: {volume}" |
*
* @param {Coaching_Workout_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_workout_line = /** @type {((inputs: Coaching_Workout_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Workout_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_workout_line(inputs)
	if (locale === "es-419") return es_419_coaching_workout_line(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_workout_line(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_workout_line(inputs)
	if (locale === "de-DE") return de_de2_coaching_workout_line(inputs)
	if (locale === "it-IT") return it_it2_coaching_workout_line(inputs)
	return en_us2_coaching_workout_line(inputs)
});
export { coaching_workout_line as "coaching.workout_line" }